import { render, staticRenderFns } from "./manage-books.vue?vue&type=template&id=41c4a9f6&scoped=true&"
import script from "./manage-books.vue?vue&type=script&lang=js&"
export * from "./manage-books.vue?vue&type=script&lang=js&"
import style0 from "./manage-books.vue?vue&type=style&index=0&id=41c4a9f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c4a9f6",
  null
  
)

export default component.exports